import * as yup from 'yup'

export const contactObjectSchema = yup.object().shape(
  {
    name: yup.string().when(['email', 'phone'], {
      is: (email?: string, phone?: string) => !!email || !!phone,
      then: (schema) => schema.required('Campo obrigatório'),
      otherwise: (schema) => schema.notRequired(),
    }),
    email: yup
      .string()
      .email('E-mail inválido')
      .when(['name', 'phone'], {
        is: (name?: string, phone?: string) => !!name || !!phone,
        then: (schema) => schema.required('Campo obrigatório'),
        otherwise: (schema) => schema.notRequired(),
      }),
    phone: yup
      .string()
      .transform((curr, orig) => (orig === '' ? null : curr))
      .notRequired()
      .nullable(),
  },
  [
    ['email', 'name'],
    ['name', 'phone'],
  ]
)

export default yup.object().shape({
  name: yup.string().required('Campo obrigatório'),
  contacts: yup.array().of(contactObjectSchema),
})
